import { AbstractControl, ValidationErrors } from '@angular/forms';

export function emailOrPhoneValidator(control: AbstractControl): ValidationErrors | null {
	const val = control.value;
	if (!val) return null;
	const isPhone = /^[6-9]\d{9}$/.test(val);
	const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
	if (isPhone || isEmail) return null;

	if (/^\d+$/.test(val)) {
		if (val.length !== 10) {
			return { invalidPhoneLength: true };
		}
		if (!/^[6-9]/.test(val)) {
			return { invalidPhoneStart: true };
		}
		return { invalidPhone: true };
	}

	return { invalidEmail: true };
}
